module.exports = __webpack_public_path__ + "img/landingpage_campaign01-fase02-01reestructurar.4e6757e1.jpg";